function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 1.73926,
  width: 18.2609,
  height: 17.3913,
  rx: 4,
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4541 7.64941C14.8856 7.64941 15.2354 7.29964 15.2354 6.86816C15.2354 6.43669 14.8856 6.08691 14.4541 6.08691C14.0226 6.08691 13.6729 6.43669 13.6729 6.86816C13.6729 7.29964 14.0226 7.64941 14.4541 7.64941Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0557 7.64941C11.4871 7.64941 11.8369 7.29964 11.8369 6.86816C11.8369 6.43669 11.4871 6.08691 11.0557 6.08691C10.6242 6.08691 10.2744 6.43669 10.2744 6.86816C10.2744 7.29964 10.6242 7.64941 11.0557 7.64941Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.65723 11.0479C8.0887 11.0479 8.43848 10.6981 8.43848 10.2666C8.43848 9.83513 8.0887 9.48535 7.65723 9.48535C7.22575 9.48535 6.87598 9.83513 6.87598 10.2666C6.87598 10.6981 7.22575 11.0479 7.65723 11.0479Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.25879 7.64941C4.69026 7.64941 5.04004 7.29964 5.04004 6.86816C5.04004 6.43669 4.69026 6.08691 4.25879 6.08691C3.82732 6.08691 3.47754 6.43669 3.47754 6.86816C3.47754 7.29964 3.82732 7.64941 4.25879 7.64941Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.25879 11.0479C4.69026 11.0479 5.04004 10.6981 5.04004 10.2666C5.04004 9.83513 4.69026 9.48535 4.25879 9.48535C3.82732 9.48535 3.47754 9.83513 3.47754 10.2666C3.47754 10.6981 3.82732 11.0479 4.25879 11.0479Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.25879 14.4463C4.69026 14.4463 5.04004 14.0965 5.04004 13.665C5.04004 13.2336 4.69026 12.8838 4.25879 12.8838C3.82732 12.8838 3.47754 13.2336 3.47754 13.665C3.47754 14.0965 3.82732 14.4463 4.25879 14.4463Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.65723 14.4463C8.0887 14.4463 8.43848 14.0965 8.43848 13.665C8.43848 13.2336 8.0887 12.8838 7.65723 12.8838C7.22575 12.8838 6.87598 13.2336 6.87598 13.665C6.87598 14.0965 7.22575 14.4463 7.65723 14.4463Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M7.65723 7.64941C8.0887 7.64941 8.43848 7.29964 8.43848 6.86816C8.43848 6.43669 8.0887 6.08691 7.65723 6.08691C7.22575 6.08691 6.87598 6.43669 6.87598 6.86816C6.87598 7.29964 7.22575 7.64941 7.65723 7.64941Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.2176,
  cy: 14.3475,
  r: 5.15217,
  fill: "currentColor",
  stroke: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7656 13.9344H15.4254V13.0327C15.4254 12.5583 15.0868 12.1738 14.6692 12.1738C14.2516 12.1738 13.9131 12.5583 13.9131 13.0327V14.7933C13.9131 15.2676 14.2516 15.6521 14.6692 15.6521H15.7656C16.1833 15.6521 16.5218 15.2676 16.5218 14.7933C16.5218 14.3189 16.1833 13.9344 15.7656 13.9344Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 3.47852,
  width: 1.47826,
  height: 3.91304,
  rx: 0.73913,
  fill: "currentColor"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 8.69531,
  width: 1.47826,
  height: 3.91304,
  rx: 0.73913,
  fill: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 13.9131,
  width: 1.47826,
  height: 3.91304,
  rx: 0.73913,
  fill: "currentColor"
});

var SvgLawyerAvailability = function SvgLawyerAvailability(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLawyerAvailability, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lawyer_availability.1872abed.svg";
export { ForwardRef as ReactComponent };